module.exports = __webpack_public_path__ + "img/Daily-Deals.e185e856.svg";